import * as variables from 'variables';
import breackpointsEvents from 'utils/breackpointsEvents';
import syncHeight from 'utils/syncHeight';
import dimension from 'utils/dimension';

export default function syncHeightWrapper() {
	breackpointsEvents(dimension.getWidthWindow, variables.breakpointsPixels, 'BSBreakpoints');

	syncHeight();
	variables.$window.on('BSBreakpoints', () => {
		syncHeight();
	});
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/syncHeightWrapper.js
 **/